import React from "react";

export const CreditCard: React.FC = () => {
  return <div data-testid="creditCardContainer" data-quickstream-api="creditCardContainer" data-hj-suppress></div>;
};

export default CreditCard;
